module.exports = __webpack_public_path__ + "static/media/leg-left-front.ebc10544.png";